import { ReactNode } from 'react';
import { Sequence, useCurrentFrame } from 'remotion';

// Components
import { CertificateCard } from './CertificateCard';
import { NumberSection } from './NumberSection';

// Utils
import { getVisibleCertificates } from '../utils';

// Types
import { EmployeeCertification } from '@/types';

interface MainSectionProps {
  certificates?: EmployeeCertification[];
  totalCertificates?: number;
  animationDelay?: number;
}

export const MainSection = ({
  certificates = [],
  totalCertificates = 0,
  animationDelay = 0,
}: MainSectionProps): ReactNode => {
  const rawFrame = useCurrentFrame();
  const frame = Math.max(0, rawFrame - animationDelay);

  const visibleCertificates = getVisibleCertificates({
    certificates,
    currentFrame: frame,
  });

  return (
    <Sequence name="Main Section" className="z-10">
      <div className="relative size-full">
        {/* Shared persistent number section — stays visible and slides from left to right */}
        <NumberSection
          totalCertificates={totalCertificates}
          certificates={certificates}
          animationDelay={animationDelay}
        />

        {/* Certificate detail cards (bottom section only) */}
        {visibleCertificates.map((item) => {
          const isLatestItem = item.index === visibleCertificates.length - 1;

          return (
            item.isVisible && (
              <CertificateCard
                key={item.index}
                certificate={item.certificate}
                startFrame={item.startFrame}
                transitionStartFrame={item.transitionStartFrame}
                isFlipped={item.isFlipped}
                isLatest={isLatestItem}
                animationDelay={animationDelay}
              />
            )
          );
        })}
      </div>
    </Sequence>
  );
};
